import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';

import {userLogout,forbiddenAccess} from  './auth';
const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
    .use(function(req) {
        req.on('response', function (res) {
            if (res.status === 401) {
console.log('UnAuthorized');
              userLogout();
                
            }else if(res.status === 403){
              console.log('Forbidden');
              forbiddenAccess();
            }
        });
});


export function setGreetingSuccess({ greeting }) {
  return {
    type: types.SET_GREETING_SUCCESS,
    greeting,
  };
}

export function setGreetingFail() {
  return {
    type: types.SET_GREETING_FAIL,
  };
}

export function getGreetingSuccess({ greeting }) {
  return {
    type: types.GET_GREETING_SUCCESS,
    greeting,
  };
}

export function getGreetingFail() {
  return {
    type: types.GET_GREETING_FAIL,
  };
}

export function resetGreetingStart() {
  return {
    type: types.RESET_GREETING_START,
  };
}

export function resetGreetingSuccess() {
  return {
    type: types.RESET_GREETING_SUCCESS,
  };
}

export function resetGreetingFail() {
  return {
    type: types.RESET_GREETING_FAIL,
  };
}

export function setGreeting(audio) {
  return (dispatch, getState) => {
    const { auth } = getState();
    const params = Object.assign({}, {
      id: auth.userid,
    });

    request.post(`${window.Config.API_URL}/business/greeting`).withCredentials().set('X-Request-ID', uuidv4())
      .field(params)
      .attach('file', audio)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(setGreetingSuccess({
            greeting: `${window.Config.API_URL}/${resp.body.filename}?t=${Date.now()}`,
          }));
        } else {
          dispatch(setGreetingFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
  };
}

export function getGreeting() {
  return (dispatch) => {
    request.get(`${window.Config.API_URL}/business/greeting`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getGreetingSuccess({
          greeting: `${window.Config.API_URL}/${resp.body.filename}?t=${Date.now()}`,
        }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getGreetingFail());
      });
  };
}

export function resetGreeting() {
  return (dispatch, getState) => {
    dispatch(resetGreetingStart());

    const { auth } = getState();
    const params = Object.assign({}, {
      id: auth.userid,
    });

    request.post(`${window.Config.API_URL}/business/greeting/reset`).withCredentials().set('X-Request-ID', uuidv4())
      .send(params)
      .then(() => {
        dispatch(resetGreetingSuccess());
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(resetGreetingFail());
      });
  };
}
